import BillingsOrderTaxiRailyAddParams, {
  BillingsOrderTaxiRailyAddParamsBillingNode,
} from "../../../../../common/services/billings/order/taxi-raily/add/billings-order-taxi-raily-add-params";
import BillingsNode from "../../../common/types/billings-node";
import BillingFormData from "../types/billing-form.data";

const createSaveBillingRequestNode = (
  node: BillingsNode,
): BillingsOrderTaxiRailyAddParamsBillingNode => {
  return {
    allowCharge: node.isHighwayAllowed,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventUuid,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.isEditable,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.id,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeId,
    orderId: node.orderId,
    plannedDate: node.plannedDate,
    plannedDistance: node.plannedDistance,
  };
};

const createSaveBillingRequestNodes = (
  nodes: BillingsNode[],
): BillingsOrderTaxiRailyAddParamsBillingNode[] => {
  return nodes.map(createSaveBillingRequestNode);
};

const createSaveBillingRequest = (
  data: BillingFormData,
  orderId: string,
): BillingsOrderTaxiRailyAddParams => {
  return {
    orderId,
    billingNodes: createSaveBillingRequestNodes(data.billingNodes),
    billingType: "PUB_CARGO_2_RAILY",
    discount: data.discount,
  };
};

const billingSaveRequestFactory = {
  createSaveBillingRequest,
};

export default billingSaveRequestFactory;
